





























































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';



@Component
export default class MultiFactorAuthentication extends Vue {
  @Prop({default:null}) public mode : Common.mfaFlags;
  show :boolean = true;

  //エントリダイアログ
  m_initialize = false;
  m_send_sms = false;  
  m_duplicate_session = false;
  m_update_session = false;
  m_update_sms = false;  
  m_reset_confirm = false;
  m_reset_invalid = false;

  //後続ダイアログ
  m_initialize_sms = false;
  m_validate_code = false;  
  m_reset_sms = false;  
  m_reset_sms_wait = false;  
  m_result = false;
  m_invalid_code = false;
  //プロパティ
  useSMS:boolean = false;
  updateTelNo = false;
  

  public telNo : string = '';
  public authenticationCode :string = '';
  public authenticationHash : string = '';

  public message = '';
  public reload = false;

  public created(){
    if (this.mode == Common.mfaFlags.initialize) this.m_initialize = true;
    else if (this.mode == Common.mfaFlags.duplicate_session) this.m_duplicate_session = true;
    else if (this.mode == Common.mfaFlags.send_sms) this.$api.multiFactorAuthenticate(new Common.MFASettingQuery()).then(result => {this.telNo = (result as Common.MFASetting).smsTelNo; this.m_send_sms = true;});
    else if (this.mode == Common.mfaFlags.update_session) this.m_update_session = true;
    else if (this.mode == Common.mfaFlags.update_sms) this.m_update_sms = true;
    else if (this.mode == Common.mfaFlags.reset_sms) this.m_reset_sms = true;        
    else if (this.mode == Common.mfaFlags.reset_confirm) this.m_reset_confirm = true;            
    else if (this.mode == Common.mfaFlags.reset_invalid) this.m_reset_invalid = true;              
  }

  public logout(){
      //ログアウト
      this.show = false;      
      this.$api.auth.logout();
  }

  public showResult(enabled:boolean, reload : boolean){

      this.message = enabled ? 'SMS認証を有効化しました。':'SMS認証を無効化しました。';
      this.reload = reload;
      this.m_result = true;
  }

  public close(reload:boolean){
      this.show = false;
      if (reload) {
          if (location.href.indexOf('?') > -1) location.href = location.href.substring(0,location.href.indexOf('?') -1);          
          else location.reload();
      }
  }

　//***初期化画面***
  public onInitialize(){
      if (this.useSMS) this.m_initialize_sms = true;
      else {
          //セッション認証を初期化する
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, true);
        });               
      }
  }

　//***SMS初期化***
　public onInitializeSMS(event:any){
     const textBox = (this.$refs.telNo as any) as Components.IControl;
     if (textBox.validator.validate() == false) {
         event.preventDefault();
         return;
     }
     //認証コードをSMSに送信
     this.$api.multiFactorAuthenticate(new Common.SMSSendCodeQuery(this.telNo)).then(hash =>{
        this.authenticationHash = hash;
        this.m_validate_code = true;
     });     
　}
   public onInitializeSMSCancel(){
       //初期化・再設定の開始画面に戻る
       if (this.mode == Common.mfaFlags.initialize) this.m_initialize = true;
       else if (this.mode == Common.mfaFlags.duplicate_session) this.m_duplicate_session = true;
       else if (this.mode == Common.mfaFlags.update_session) this.m_update_session = true;
       else if (this.mode == Common.mfaFlags.update_sms) this.m_update_sms = true;       
   }

　//***認証実施***
   public onValidateCode(event : any){
     const textBox = (this.$refs.authenticationCode as any) as Components.IControl;
     if (textBox.validator.validate() == false) {
         event.preventDefault();
         return;
     }
     var initialize = this.mode == Common.mfaFlags.send_sms ? false : true; //認証以外は初期化・リセット系
     this.$api.multiFactorAuthenticate(new Common.SMSValidateCodeQuery(this.telNo,this.authenticationCode,this.authenticationHash, initialize)).then(result =>{        
        if (result) { 
            if (initialize) this.showResult(true, true);
            else this.close(true);
        }
        else this.m_invalid_code = true; //結果表示後、再度、認証コード送信画面に遷移。
     });          
   }

   public onValidateCodeCancel(){
       //「認証コードの送信」もしくは「携帯電話番号の指定」に戻る
      if (this.mode ==  Common.mfaFlags.send_sms) this.m_send_sms = true;
      else this.m_initialize_sms = true;
   }

　//***セッション重複エラー***
　public onDuplicateSession(){
     this.m_initialize_sms = true;
   }

　//***認証コード送信***
   public onSendSMS(){
     //認証コードをSMSに送信～telNoはマスクされているので送らない
     this.$api.multiFactorAuthenticate(new Common.SMSSendCodeQuery(null)).then(hash =>{
        this.authenticationHash = hash;
        this.m_validate_code = true;
     });            
   }
   public onSendSMSReset(){
       this.m_send_sms = false;
       this.m_reset_sms = true;       
   }
   public onUpdateSMS() {
       if (this.updateTelNo) this.m_initialize_sms = true;
       else {
        //SMS認証解除
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, false); //リロード不要
        });                     
       }
   }

   public onResetSMS() {
       //SMS認証解除メールを送信する
        //SMS認証解除
        this.$api.multiFactorAuthenticate(new Common.MFAResetMailQuery()).then(result =>{
            this.m_reset_sms_wait = true;
        });    
   }

   public onResetSMSCancel(){
       this.m_send_sms = true;
   }

   public onResetConfirm() {
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, true); //リロード必要  
        });             
   }

   public onResetInvalid(){
        this.close(true); //リロード必要             
   }

   public onInvalidCode(){
       if (this.mode == Common.mfaFlags.send_sms) this.m_send_sms = true;
       else this.m_initialize_sms = true;
   }
}
